// Core
import React, { useEffect, useState } from "react";

// Redux
import { useDispatch } from "react-redux";
import {
  getNotificationSettingsRequest,
  updateNotificationSettingsRequest,
} from "../../../../../Redux/Slices/Common/commonSlice";

// Custom component
import CustomSwitch from "Components/CustomSwitch";
import Button from "Components/Button";

// Custom functions
import { notifySuccess } from "Services/Utils/toastNotification";

const NotificationSettings = ({ goToNextTab }) => {
  //Initialize redux
  const dispatch = useDispatch();

  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [browserNotificationEnabled, setBrowserNotificationEnabled] =
    useState(false);
  const [notificationId, setNotificationId] = useState("");

  useEffect(() => {
    getNotificationSettingsRequestCall();
  }, []);

  const getNotificationSettingsRequestCall = () => {
    // To get notification settings
    dispatch(
      getNotificationSettingsRequest({
        callBack: getNotificationSettingsCBRequest,
      })
    );
  };

  // To handle the response of getNotificationSettingsRequest
  const getNotificationSettingsCBRequest = (data) => {
    setNotificationsEnabled(data?.on_web_app_notification);
    setBrowserNotificationEnabled(data?.browser_notification);
    setNotificationId(data?.notification_setting_id);
  };

  const buttonTitleStyle = {
    fontSize: "15px",
    fontWeight: "600",
  };

  const buttonStyle = {
    height: "44px",
    width: "170px",
    whiteSpace: "nowrap"
  };
  const handleSubmit = () => {
    dispatch(
      updateNotificationSettingsRequest({
        notificationId: notificationId,
        data: {
          on_web_app_notification: notificationsEnabled,
          browser_notification: browserNotificationEnabled,
        },
        callBack: updateNotificationSettingsCBRequest,
      })
    );
  };

  // To handle the response of updateNotificationSettingsRequest
  const updateNotificationSettingsCBRequest = () => {
    notifySuccess("Notification settings updated successfully!");
    goToNextTab();
  };

  return (
    <div className="notification-settings p-4">
      <h5>On Web App Notification</h5>
      
      <div className="notification-setting-element  mt-4 ms-4">
        <CustomSwitch
          label="Get Notifications from Assessor and Admin"
          checked={notificationsEnabled}
          onChange={() => setNotificationsEnabled(!notificationsEnabled)}
        />
      </div>

      <hr />

      <h5>Browser Notification</h5>
      <div className="notification-setting-element ms-4 mt-4">
        <CustomSwitch
          label="Get Notifications on your computer"
          checked={browserNotificationEnabled}
          onChange={() =>
            setBrowserNotificationEnabled(!browserNotificationEnabled)
          }
        />
      </div>

      <div className="col-2 mt-5">
        <Button
          title="Submit & Next"
          titleStyle={buttonTitleStyle}
          buttonStyle={buttonStyle}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default NotificationSettings;
